import type { RootState } from 'syft-acp-core/reducers'

export const selectEmployerVenueSearch = (state: RootState) => state.employerVenueSearch

export const selectVenueName = (state: RootState, venueID?: string) =>
  venueID ? state.employerVenueSearch.namesById[venueID] : undefined
